import { Action } from '@ngrx/store';

/** OverlayActionType */
export enum OverlayActionType {
    TOGGLE_OVERLAY = 'TOGGLE_OVERLAY',
}
/** ToggleOverlayAction */
export class ToggleOverlayAction implements Action {
    /** type */
    public readonly type = OverlayActionType.TOGGLE_OVERLAY;
    /** constructor */
    public constructor (
        /** payload */
        public payload: {
            /** modalName */
            modalName: string}) {
    }
}
